export class StockEntryStateModel {
  lotId: string | null = null;
  lotNumero: number | null = null;
  lotSacaNumero: string | null = null;
  lotStatus: number | null = null;
  lotQuantityChecked: number | null = null;
  lotQuantityToCheck: number | null = null;
  lotTotalQuantity: number | null = null;
  lotDate: string | null = null;
  receiptInvoiceKey: string | null = null;
  receiptTradeId: string | null = null;
  receiptImei: string | null = null;
}

export class SetLot {
  static readonly type = '[StockEntry] Set Lot';
  constructor(
    public payload: {
      id: string;
      numero: number;
      sacaNumero?: string;
      status: number;
      quantityChecked?: number;
      quantityToCheck?: number;
      totalQuantity?: number;
      lotDate?: string;
    }
  ) {}
}

export class SetReceiptFields {
  static readonly type = '[StockEntry] Set Receipt Fields';
  constructor(
    public payload: {
      invoiceKey: string;
      tradeId: string;
      imei: string;
    }
  ) {}
}

export class ClearLot {
  static readonly type = '[StockEntry] Clear Lot';
}
